import {
    SET_BANNER_MESSAGE,
    BANNER_MESSAGE_DISPLAY,
    MARQUEE_BANNER_FLAG,
    BANNER_LOAD_REQUEST,
    BANNER_LOAD_SUCCESS,
    BANNER_LOAD_FAILURE
} from '../Banner/BannerConstants';
import AppService from 'Global/AppService';
import moment from 'moment';
import { getBannerMessageUrl } from 'ECD/NGIApiUrls';

const loadBannerMessages = (url, forceRefresh = false) => {

    return (dispatch, getState) => {
        const { isBannerFetching, isBannerFetched } = getState().BannerReducer;
        if (isBannerFetching || (!forceRefresh && isBannerFetched)) return;

        dispatch({ type: BANNER_LOAD_REQUEST });

        function callbackOnLoadBannerMessage(success, err) {
            if (success && success.result) {

                const timerSetFromUserInHours = success.result.bannerTimerInHours || 72;
                const message = success.result.bannerObject[0];

                if (moment.utc().isBefore(moment.utc(success.result.bannerObject[2]).add(timerSetFromUserInHours, 'hours'))) {
                    dispatch({ type: SET_BANNER_MESSAGE, newState: { bannerMessage: message } });
                    dispatch({ type: BANNER_MESSAGE_DISPLAY, newState: { bannerMessageDisplay: message } });
                    dispatch({ type: MARQUEE_BANNER_FLAG, newState: { marqueeBannerFlag: true } });
                } else {
                    dispatch({ type: MARQUEE_BANNER_FLAG, newState: { marqueeBannerFlag: false } });
                }
                dispatch({ type: BANNER_LOAD_SUCCESS });
            } else {
                dispatch({ type: BANNER_LOAD_FAILURE });
            }
        }
        AppService.getData(url, callbackOnLoadBannerMessage);
    }
}

const saveBannerMessage = (url, payload) => {

    return (dispatch) => {
        dispatch({ type: MARQUEE_BANNER_FLAG, newState: { marqueeBannerFlag: false } });
        function callbackOnSaveBannerMessage(success, err) {
            if (success) {
                dispatch({ type: MARQUEE_BANNER_FLAG, newState: { marqueeBannerFlag: true } });
                dispatch({ type: SET_BANNER_MESSAGE, newState: { bannerMessage: payload.bannerMessage } });
                dispatch({ type: BANNER_MESSAGE_DISPLAY, newState: { bannerMessageDisplay: payload.bannerMessage } });
                dispatch(loadBannerMessages(getBannerMessageUrl().url, true));
            }
            else if(err.status!=200){
                dispatch({ type: MARQUEE_BANNER_FLAG, newState: { marqueeBannerFlag: true } });
            }
        }
        AppService.postData(payload, url, callbackOnSaveBannerMessage);
    }
}

export {
    loadBannerMessages,
    saveBannerMessage
}
